import { SITE_VARIABLES } from '../../../../../common/styles/variables';

interface StylesObject {
    storyBarProgressStyle: { [key: string]: any };
}

interface StoryBarProgressStyleObject {
    root: { [key: string]: any };
}

const storyBarProgress = (storyTime: number, isCurrentStory: boolean, storyDuration: number, isStoryEnded: boolean, isSeeking: boolean, brandingColor: string): StoryBarProgressStyleObject => {
  const backgroundColor = brandingColor || SITE_VARIABLES.COLORS.WHITE;
  const otherStoriesWidth = isStoryEnded ? '100%' : '0';
  return {
    root: {
      width: isCurrentStory ? `${(storyTime / storyDuration) * 100}%` : otherStoriesWidth,
      maxWidth: '100%',
      height: '100%',
      left: '0',
      backgroundColor,
      borderRadius: 'inherit',
      transition: !isSeeking ? 'width 0.2s ease-in' : 'unset',
    },
  };
};
export const getStorySeekBarProgressStyleObject = (isStoryEnded: boolean, isCurrentStory: boolean, storyTime: number, storyDuration: number, isSeeking: boolean, brandingColor: string | null): StylesObject => {
  const seekBarProgressStyleObject = storyBarProgress(storyTime, isCurrentStory, storyDuration, isStoryEnded, isSeeking, brandingColor);
  return ({
    storyBarProgressStyle: [
      seekBarProgressStyleObject.root,
    ],
  });
};
